module.exports = __webpack_public_path__ + "img/grid_map_click.cfd2c68b.svg";